import React, { useMemo, useState } from "react";
import { Image } from "shared/assets/icons";

import { GalleryModal, ImageGalleryItem, ImageTeaser, ImageTeaserProps } from "shared/components";
import { StyledImageGrid } from "./styles";

interface ImageGridProps {
  breadcrumbs?: string | string[];
  images: ImageTeaserProps[];
  maxNbRows?: number;
}

export const ImageGrid: React.FC<ImageGridProps> = ({ images, maxNbRows, breadcrumbs }) => {
  const [isGalleryOpen, setIsGalleryOpen] = useState<boolean>(false);
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const visibleImages = useMemo(
    () => (maxNbRows ? images.slice(0, maxNbRows * 4) : images),
    [images, maxNbRows]
  );

  const nbMoreImages = maxNbRows ? images.length - visibleImages.length + 1 : 0;
  const showMoreOverlay = maxNbRows && nbMoreImages > 1;

  const imageSlides = useMemo(
    () =>
      images.map((image, index) => (
        <ImageGalleryItem key={index} {...image} currentIndex={index} nbItems={images.length} />
      )),
    [images]
  );

  const onImageClick = (index: number) => {
    setIsGalleryOpen(true);
    setActiveIndex(index);
  };

  return (
    <>
      <StyledImageGrid>
        {visibleImages.map((image, index) => (
          <ImageTeaser
            {...image}
            key={image.id}
            onClick={() => onImageClick(index)}
            nbMoreitems={
              showMoreOverlay && index === visibleImages.length - 1 ? nbMoreImages : undefined
            }
          />
        ))}
      </StyledImageGrid>
      {isGalleryOpen && (
        <GalleryModal
          icon={Image}
          title={breadcrumbs}
          items={imageSlides}
          handleClose={() => setIsGalleryOpen(false)}
          initIndex={activeIndex}
        />
      )}
    </>
  );
};
